export const SITE = {
  name: "The Vantage Institute™",
  shortName: "Vantage Institute",
  positioning: "Executive Education • Research • Intellectual Capital",
  promise: "Think Better. Lead Better. Perform Better. Transform Better.",
  group: "A Vantage Group™ Institution",
  division: "An Executive Education & Research Division of Wowrakesh Business Academy®",
  mission:
    "Develop leadership capability, strategic thinking, business skills and practical intellectual capital for leaders, professionals, entrepreneurs and organisations.",
};

export const NAV_PRIMARY = [
  { label: "Programmes", to: "/programmes" },
  { label: "Learning Paths", to: "/learning" },
  { label: "Thinking Toolbox", to: "/thinking-toolbox" },
  { label: "For Organisations", to: "/organisations" },
  { label: "Knowledge", to: "/knowledge" },
  { label: "About", to: "/about" },
];

export const NAV_ALL = [
  { label: "Home", to: "/" },
  { label: "Learn", to: "/learning" },
  { label: "Programmes", to: "/programmes" },
  { label: "Learning Paths", to: "/learning" },
  { label: "Thinking Toolbox™", to: "/thinking-toolbox" },
  { label: "For Organisations", to: "/organisations" },
  { label: "Advisory (Vantage Group™)", to: "/advisory" },
  { label: "Knowledge Hub", to: "/knowledge" },
  { label: "Events", to: "/events" },
  { label: "About", to: "/about" },
  { label: "Founder", to: "/founder/rakesh-gopinathan" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  email: "rakesh@wba.org.in",
  phoneDisplay: "+91 75501 92649",
  phoneHref: "tel:+917550192649",
  whatsapp: "https://wa.me/917550192649",
};

export const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/rakeshgopinathan/" },
  { label: "Instagram", href: "https://instagram.com/TheVantageInstitute" },
  { label: "Facebook", href: "https://facebook.com/VantageInstituteIndia" },
  { label: "X (Twitter)", href: "https://x.com/TVGAdvisory" },
  { label: "WhatsApp", href: "https://wa.me/917550192649" },
];

export const LEGAL = [
  { label: "Privacy Policy", to: "/legal/privacy-policy" },
  { label: "Terms", to: "/legal/terms" },
  { label: "Cookie Policy", to: "/legal/cookie-policy" },
  { label: "Disclaimer", to: "/legal/disclaimer" },
];
